<template>
  <div>
    <div class="banner">
      <img src="/static/images/banner-solution.png">
    </div>
    <div class="box">
      <div class="title">传统企业物流运输碰到的问题</div>
      <span class="title-line"></span>
      <div class="width1200 el-row--flex is-justify-space-between">
        <div class="question el-row--flex is-align-middle">
          <div class="question-img el-row--flex is-justify-center is-align-middle">
            <img src="/static/images/icon/icon-question-1.png">
          </div>
          <div class="question-title">税务规划</div>
          <div class="question-sub-title">传统物流企业票务税务存在很大问题，有些个人、中小型企业在货运经营过程中无法取得货物运输增值税发票导致企业无法抵扣税务等问题</div>
        </div>
        <div class="question el-row--flex is-align-middle">
          <div class="question-img el-row--flex is-justify-center is-align-middle">
            <img src="/static/images/icon/icon-question-2.png">
          </div>
          <div class="question-title">车源整合</div>
          <div class="question-sub-title">运输配送过程中的不可控，找不到合适的司机，效率低成本高等是企业遇到的普遍问题和难点</div>
        </div>
        <div class="question el-row--flex is-align-middle">
          <div class="question-img el-row--flex is-justify-center is-align-middle">
            <img src="/static/images/icon/icon-question-3.png">
          </div>
          <div class="question-title">过程管控</div>
          <div class="question-sub-title">不能及时掌握运输情况需求以及物流轨迹分析，生命周期的跟踪与分析、运输路径优化、仓储优化、运营分析</div>
        </div>
        <div class="question el-row--flex is-align-middle">
          <div class="question-img el-row--flex is-justify-center is-align-middle">
            <img src="/static/images/icon/icon-question-4.png">
          </div>
          <div class="question-title">物流管理</div>
          <div class="question-sub-title">传统的物流行业，存在着很多经营或管理上的问题，价格上的差异，管理上的混乱，车辆分散等等，导致物流企业的效益降低</div>
        </div>
      </div>
    </div>
    <div class="box bgf5">
      <div class="title">为什么要选择成易网运</div>
      <span class="title-line"></span>
      <div class="width1200">
        <div class="choose el-row--flex is-justify-space-between is-align-middle">
          <img src="/static/images/choose-1.png">
          <div>
            <div class="choose-title">什么是网络货运</div>
            <div class="choose-sub-title">税务合规是刚需，产业升级是重点</div>
            <div class="choose-content">成易在2020年取得网络货运平台资质，结合当地财税优惠政策，自研网路货运平台系统。对物流企业来说，网络货运不仅是打通监管链路，实现合规发展的前提，也是提升自身资产价值的重要方式。</div>
            <div class="choose-sub-title">解决企业进项难题</div> <div class="choose-content">提供个体司机带票运输解决方案，解决物流企业进项难题，避免“白条”风险，避免第三方平台开票风险和成本，确保税务合规。</div>
          </div>
        </div>
        <div class="choose el-row--flex is-justify-space-between is-align-middle">
          <div>
            <div class="choose-title">成易 -网络货运平台模式解析</div>
            <div class="choose-sub-title">网络货运管理平台</div>
            <div class="choose-content">为平台管理员提供系统运营管理功能</div>
            <div class="choose-sub-title">司机端小程序</div>
            <div class="choose-content">供司机查看订单及运单详情信息，并在线签约进行货物运输</div>
            <div class="choose-sub-title">业务员小程序</div>
            <div class="choose-content">供货主方查看运单及创建、向司机推送运单信息等全业务操作流程</div>
          </div>
          <img src="/static/images/choose-2.png">
        </div>
        <div class="choose el-row--flex is-justify-space-between is-align-middle">
          <img src="/static/images/choose-3.png">
          <div>
            <div class="choose-title">成易网络货运平台系统功能优势</div>
            <div class="choose-sub-title">平台功能强大、灵活</div>
            <div class="choose-content">不仅支持承运人为个体司机模式，同时还支持承运商经纪人等模式</div>
            <div class="choose-sub-title">微信小程序搭配，操作更便捷</div>
            <div class="choose-content">避免司机不愿下载APP或版本兼容及升级问题，有效提升司机满意度。</div>
            <div class="choose-sub-title">证件OCR自动识别</div>
            <div class="choose-content">支持实名认证和图片自动识别校验</div>
            <div class="choose-sub-title">电子签约</div>
            <div class="choose-content">支持在线签署电子合同，可解决个体司机运费专票获取难题</div>
          </div>
        </div>
      </div>
    </div>
    <div class="box">
      <div class="title">我们的核心竞争力</div>
      <span class="title-line"></span>
      <div class="width1200 el-row--flex is-justify-space-between">
        <div class="core">
          <img src="/static/images/core-1.png">
          <div>自研APP以及运营后台，借助互联网技术，打通运力调度、承运等环节，实现业务线上流程，确保物流业务透明化，提升运营效率</div>
        </div>
        <div class="core">
          <img src="/static/images/core-2.png">
          <div>专属服务经理一对一驻地支持，使企业员工快速熟悉业务流程，提高管理能力。</div>
        </div>
        <div class="core">
          <img src="/static/images/core-3.png">
          <div>7*12小时专业指导，随时随地为您答惑解疑</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {

      }
    }
  }
</script>

<style lang="scss">
  .title-line {
    display: inline-block;
    width: 40px;
    height: 4px;
    margin-top: 30px;
    background-color: #0b5bdc;
  }

  .question {
    flex-flow: column;
    margin: 86px auto 63px;

    &-img {
      width: 60px;
      height: 60px;
    }

    &-title {
      margin-top: 40px;
      font-size: 20px;
      color: #333;
    }

    &-sub-title {
      width: 239px;
      margin-top: 15px;
      font-size: 14px;
      color: #666
    }
  }

  .choose {
    margin-top: 186px;
    text-align: left;

    &:first-child {
      margin-top: 86px;
    }

    &:last-child {
      padding-bottom: 86px;
    }

    & > div {
      width: 425px;
    }

    &-title {
      font-size: 24px;
      font-weight: 700;
      color: #000;
    }

    &-sub-title {
      margin-top: 34px;
      font-size: 18px;
      color: #333;
    }

    &-content {
      margin-top: 5px;
      font-size: 14px;
      color: #999;
    }
  }

  .core {
    width: 392px;
    margin: 86px auto 80px;

    div {
      width: 345px;
      margin-left: 7px;
      margin-top: 3px;
      font-size: 15px;
      font-weight: 300;
      color: #666;
      text-align: left;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/solution.vue